import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

export const TIPO_DOCUMENTO_OPTS = [
  { value: 'remision', label: 'Cotización' },
  { value: 'iva', label: 'Factura' },
];

export const FORMA_PAGO_OPTS = [
  { value: 'contado', label: 'Contado' },
  { value: 'credito_15', label: 'Crédito 15 días' },
  { value: 'credito_20', label: 'Crédito 20 días' },
  { value: 'credito_30', label: 'Facturación a 30 días' },
];

export const TRANSPORTADORAS = [
  '',
  'Coordinadora',
  'Servientrega',
  'Interrapidísimo',
  'Envía',
  'TCC',
  'Deprisa',
  'Recoge en bodega',
  'Otra',
];

export function labelTipoDocumento(v) {
  if (!v) return null;
  return TIPO_DOCUMENTO_OPTS.find((o) => o.value === v)?.label || v;
}

export function labelFormaPago(v) {
  if (!v) return null;
  return FORMA_PAGO_OPTS.find((o) => o.value === v)?.label || v;
}

function opcionesResumen(meta) {
  const parts = [];
  if (meta.transportadora && meta.transportadora !== 'Otra') {
    parts.push(meta.transportadora);
  } else if (meta.transportadora === 'Otra' && meta.transportadora_otra) {
    parts.push(meta.transportadora_otra);
  }
  if (meta.tipo_documento) parts.push(labelTipoDocumento(meta.tipo_documento));
  if (meta.forma_pago) parts.push(labelFormaPago(meta.forma_pago));
  if (meta.horario_recibo) parts.push('Horario ✓');
  return parts.length ? parts.join(' · ') : 'Sin opciones adicionales';
}

export default function PedidoOpciones({ collapsible = true }) {
  const { state, dispatch } = useCart();
  const meta = state.pedidoMeta;
  // Cerrado por defecto: el bloque queda sticky al pie del carrito y siempre visible.
  const [open, setOpen] = useState(false);

  function set(field, value) {
    dispatch({ type: 'SET_PEDIDO_META', data: { [field]: value } });
  }

  function toggleOpen() {
    setOpen((v) => !v);
  }

  const resumen = opcionesResumen(meta);

  const form = (
    <div className="pedido-opciones-body">
      <label className="field-label">
        Transportadora <span className="optional">(opcional)</span>
        <select value={meta.transportadora} onChange={(e) => set('transportadora', e.target.value)}>
          {TRANSPORTADORAS.map((t) => (
            <option key={t || 'none'} value={t}>{t || '— Sin transportadora —'}</option>
          ))}
        </select>
      </label>

      {meta.transportadora === 'Otra' ? (
        <label className="field-label">
          Nombre transportadora
          <input
            type="text"
            placeholder="Escribir transportadora..."
            value={meta.transportadora_otra || ''}
            onChange={(e) => set('transportadora_otra', e.target.value)}
          />
        </label>
      ) : null}

      <label className="field-label">
        Horario para recibir <span className="optional">(opcional)</span>
        <input
          type="text"
          placeholder="Ej: Lun–Vie 8:00 am – 12:00 m"
          value={meta.horario_recibo}
          onChange={(e) => set('horario_recibo', e.target.value)}
        />
      </label>

      <div className="pedido-opciones-row">
        <label className="field-label">
          Documento
          <select value={meta.tipo_documento || 'remision'} onChange={(e) => set('tipo_documento', e.target.value)}>
            {TIPO_DOCUMENTO_OPTS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </label>

        <label className="field-label">
          Forma de pago
          <select value={meta.forma_pago || 'contado'} onChange={(e) => set('forma_pago', e.target.value)}>
            {FORMA_PAGO_OPTS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );

  if (!collapsible) {
    return (
      <div className="pedido-opciones">
        <h4 className="pedido-opciones-title">Opciones del pedido</h4>
        {form}
      </div>
    );
  }

  return (
    <div className={`pedido-opciones-accordion ${open ? 'open' : ''}`}>
      <button
        type="button"
        className="pedido-opciones-toggle"
        onClick={toggleOpen}
        aria-expanded={open}
      >
        <span className="pedido-opciones-toggle-text">
          <strong>Entrega y facturación</strong>
          {!open ? <em>{resumen}</em> : <em>Transportadora, horario, documento y pago</em>}
        </span>
        <span className="pedido-opciones-chevron">{open ? '▲' : '▼'}</span>
      </button>
      {open ? form : null}
    </div>
  );
}

export function getPedidoMetaPayload(meta) {
  let transportadora = meta.transportadora?.trim() || null;
  if (transportadora === 'Otra') {
    transportadora = meta.transportadora_otra?.trim() || null;
  }
  return {
    transportadora,
    horario_recibo: meta.horario_recibo?.trim() || null,
    tipo_documento: meta.tipo_documento || null,
    forma_pago: meta.forma_pago || null,
  };
}
